import rubyIdentService from "@/services/ruby-ident.service";
import router from "@/router";
import getWithExpiry from "@/helpers/get-with-expiry";

const user = getWithExpiry('user');

const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: { loggedIn: false }, user: null };

export const rubyIdentModule = {
    namespaced: true,
    state: initialState,
    actions: {
        loginUser({ dispatch, commit }, user) {
            return new Promise((resolve, reject) => {
                rubyIdentService.loginUser(user)
                    .then(user => {
                        commit('loginUser', user);
                        router.push('/');
                        resolve(user);
                    })
                    .catch(error => {
                        dispatch('alert/error', error, { root: true });
                        commit('logoutUser');
                        reject(error);
                    });
            });

        },
        logoutUser({ dispatch, commit }) {
            return new Promise((resolve, reject) => {
                rubyIdentService.logoutUser()
                    .then(() => {
                        commit('logoutUser');
                        router.push('/sign-in');
                        resolve();
                    })
                    .catch(error => {
                        dispatch('alert/error', error, { root: true });
                        commit('logoutUser');
                        reject(error);
                    });
            });
        }
    },
    mutations: {
        loginUser(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        logoutUser(state) {
            state.status.loggedIn = false;
            state.user = null;
        }
    }
};